import { useState } from "react";
import { Alert, Button, Col, Modal, Progress, Row } from "antd";
import { DownloadOutlined, ReloadOutlined } from "@ant-design/icons";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import {
  selectConfig,
  selectWallLayout,
  shuffle,
} from "../store/slices/configurationSlice";
import { selectBrickSeries } from "../store/slices/bricksSlice";
import { exportTextureSet } from "../wall/textureSet";

const saveBlob = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const WallActions = () => {
  const dispatch = useAppDispatch();
  const layout = useAppSelector(selectWallLayout);
  const config = useAppSelector(selectConfig);
  const brickSeries = useAppSelector(selectBrickSeries);
  const [progress, setProgress] = useState<number | null>(null);
  const [error, setError] = useState<string | null>(null);
  const empty = layout.bricks.length === 0;

  const download = async () => {
    setError(null);
    setProgress(0);
    try {
      const { blob, fileName } = await exportTextureSet({
        layout,
        brickSelection: config.brickSelection,
        brickSeries,
        joint: config.joint,
        jointSize: config.jointSize,
        onProgress: setProgress,
      });
      saveBlob(blob, fileName);
      setProgress(null);
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    }
  };

  return (
    <>
      <Row gutter={16}>
        <Col span={12}>
          <Button
            block
            icon={<ReloadOutlined />}
            disabled={empty}
            onClick={() => dispatch(shuffle())}
          >
            Shuffle
          </Button>
        </Col>
        <Col span={12}>
          <Button
            block
            type="primary"
            icon={<DownloadOutlined />}
            disabled={empty || progress !== null}
            onClick={download}
          >
            Download
          </Button>
        </Col>
      </Row>
      <Modal
        open={progress !== null}
        title="Download voorbereiden"
        footer={error ? <Button onClick={() => setProgress(null)}>Sluiten</Button> : null}
        closable={false}
        mask={{ closable: false }}
      >
        {error ? (
          <Alert type="error" showIcon title="De textures konden niet gemaakt worden." description={error} />
        ) : (
          <Progress percent={Math.round((progress ?? 0) * 100)} />
        )}
      </Modal>
    </>
  );
};
